module.exports = __webpack_public_path__ + "static/media/8.9b9e7baf.jpg";